/** A study version's page in this app (SA-854 D3's address, the version always
 * named): the ONE rule for it. The picker writes it absolute (`pinHref`, SA-859)
 * and the pricing card links it as is (SA-860). */
export function versionPath(reference: string, version: number): string {
  return `/route-studies?study=${encodeURIComponent(reference)}&version=${version}`
}

/** The Workbook imports tab; `upload` opens its Import workbook dialog (SA-1037 §5.3). */
export function importsPath(upload: boolean): string {
  return upload ? '/route-studies/imports?upload=1' : '/route-studies/imports'
}
